export { default as SeekBar } from './component';
